import styled from 'styled-components'
import { colors } from 'const/colors'
import query from 'mediaQueries'
import { Link } from 'react-router-dom'
import { H4 } from 'syf-component-library/ui/typography'
import { I18N } from 'typings/custom'
import { BrcCreditBureauAddress } from './typings'

export const Container = styled.div`
  padding: 32px;
  @media ${query.greaterThanSmall} {
    padding: 32px 60px;
  }
`

export const SectionHeader = styled.p`
  padding-bottom: 32px;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.greyEighty};
`

export const QuestionSection = styled.div`
  padding: 16px 0;
`

export const Question = styled(H4)`
  font-weight: 600;
  color: ${colors.greyEighty};
  font-size: 14px;
  padding-bottom: 12px;
`

export const Text = styled.p`
  color: ${colors.lightBlack};
  margin: 0;
`

export const QuestionLink = styled(props => <Link {...props} />)`
  color: ${colors.cobalt};
`

export const List = styled.ul<{ type?: string }>`
  list-style-type: ${({ type }): string => type || 'auto'};
  padding: ${({ type }): string => (type === 'none' ? '0' : 'revert')};
  margin: 0;
  li {
    line-height: 1.5;
  }
`

export const AddressWrapper = styled.address`
  font-style: normal;
  font-weight: 600;
  padding: 12px 16px 0;
  p {
    margin: 0;
    padding: 0;
  }
`

export const brcCreditBureauQuestion = (
  i18n: I18N,
  brcCreditBureau: BrcCreditBureauAddress
) => {
  return function creditBureau() {
    const { addressee, addressLine1, city, state, zipCode } = brcCreditBureau

    return (
      <QuestionSection>
        <Question>{i18n({ faq: 'creditBureauQuestion' }) as string}</Question>
        <Text>{i18n({ faq: 'creditBureauAnswer1' }) as string}</Text>
        <AddressWrapper>
          <p>{addressee}</p>
          <p>{addressLine1}</p>
          <p>
            {city}, {state} {zipCode}
          </p>
        </AddressWrapper>
        <p>{i18n({ faq: 'creditBureauAnswer2' }) as string}</p>
      </QuestionSection>
    )
  }
}
